import { useEffect, type FunctionComponent } from 'react';
import { formatViewName, startRumView } from '@carboncopyco/logger';
import { useLocation } from 'react-router-dom';

/** Tracks all location changes in a router and logs them to datadog */
export const RumRouteTracker: FunctionComponent = () => {
  const location = useLocation();

  useEffect(() => {
    startRumView(formatViewName(location.pathname));
  }, [location.pathname]);

  return undefined;
};
